import React from 'react';
import { Route } from 'react-router-dom';
import NotFound from '.';

const route = (
    <Route path="*">
        <NotFound />
    </Route>
);

export default route;
